import { z } from 'zod';
import { AppUserType } from '~/enums/permissions/_types';
import { zDbId, zTimestamp } from '~/plugins/zod/utils';
import { LocaleSchema } from '~/plugins/i18n/_types';
import { getFullName } from '~/utils/userUtils';
import { PartnerDetailSchema } from '~/api/partners/_types';
import { ContactDetailSchema } from '~/api/contacts/_types';

export const UserPreferencesSchema = z.object({
    Locale: LocaleSchema,
});

export const AuthUserSchema = z
    .object({
        Id: zDbId(),
        FirstName: z.string(),
        LastName: z.string(),
        Email: z.string(),
        Login: z.string(),
        Type: z.nativeEnum(AppUserType),
        Preferences: UserPreferencesSchema.nullable(),
        Partner: PartnerDetailSchema.nullable(),
        Contact: ContactDetailSchema.nullable(),
    })
    .transform((val) => ({
        ...val,
        FullName: getFullName(val),
    }));

export const AuthTokenSchema = z.object({
    ExpiresAt: zTimestamp(),
    Token: z.string(),
});

export type UserPreferences = z.infer<typeof UserPreferencesSchema>;
export type AuthUser = z.infer<typeof AuthUserSchema>;
export type AuthToken = z.infer<typeof AuthTokenSchema>;
